import { useLocalObservable } from 'mobx-react-lite'
import { useMemo } from 'react'

import { UnifiedOptionStore } from '@/store/unified/unifiedOptionStore'
import { UnifiedStore as UnifiedStateStore } from '@/store/unified/unifiedStore'

export type UnifiedOptionStoreType = InstanceType<typeof UnifiedOptionStore>
export type UnifiedStateStoreType = InstanceType<typeof UnifiedStateStore>

interface IUsePageStore {
  optionStore: UnifiedOptionStoreType
  stateStore: UnifiedStateStoreType
}

export default function usePageStore(): IUsePageStore {
  const optionStore = useLocalObservable(() => new UnifiedOptionStore())
  const stateStore = useLocalObservable(() => new UnifiedStateStore())

  return useMemo(() => {
    console.log('optionStore11111', optionStore)
    return {
      optionStore,
      stateStore
    }
  }, [optionStore, stateStore])
}
